const UTILS = {
  buildWorkflowUserTransitionObject: function (modelType, modelId, userId, transition, userTransitionStore) {
    let data = { model_type: modelType, model_id: modelId, user_id: userId, transition: transition }
    let transitionIdentity = { transition: transition }
    let override = {}

    if (transition.indexOf(':') !== -1) {
      let splitted = transition.split(':')
      transitionIdentity = override = { transition: splitted[0], context: { sub: splitted[1] } }
    }

    if (userTransitionStore) {
      let existing = _.find(userTransitionStore, transitionIdentity)
      if (existing && existing.id) {
        override['id'] = existing.id
      }
    }

    return Object.assign({}, data, override)
  },
  buildWorkflowUserTransitionApplyObject: function (modelType, modelId, transition, context = {}) {
    let data = { modelType: modelType, modelId: modelId, transition: transition, context: context }
    let override = {}

    if (transition.indexOf(':') !== -1) {
      let splitted = transition.split(':')
      context['sub'] = splitted[1]
      override = { transition: splitted[0], context: context }
    }
    return Object.assign({}, data, override)
  },
  getTransitionFormDataKey: function (item) {
    return item.context && item.context.sub ? item.transition + ':' + item.context.sub : item.transition
  },
  isWorkflowNew: function (modelWorkflowUserTransitions) {
    return !modelWorkflowUserTransitions || modelWorkflowUserTransitions.length === 0
  },
  reduceWorkflowDisplayItems: function (display, userWorkflowTransitions, isEditing) {
    let displayClone = _.cloneDeep(display)

    // Reduce if data[] is empty
    return _.reduce(displayClone, function (final, dp) {
      // Fill transition config's data property with values loaded from remote.
      let reducedData = _.reduce(dp.data, function (result, data) {
        let foundIdx = -1

        if (data.context && data.context.sub) {
          foundIdx = _.findLastIndex(userWorkflowTransitions, function (tran) {
            return tran.context && tran.context.sub && tran.transition === data.transition && tran.context.sub === data.context.sub
          })
        } else {
          foundIdx = _.findLastIndex(userWorkflowTransitions, { transition: data.transition })
        }

        if (foundIdx !== -1) {
          let tranData = Object.assign({}, data, userWorkflowTransitions[foundIdx])
          // transform user to users for display
          tranData['users'] = [tranData['user']]
          delete tranData['user']
          result.push(tranData)
        } else if (isEditing) {
          result.push(data)
        }
        return result
      }, [])

      if (reducedData.length > 0) {
        dp.data = reducedData
        final.push(dp)
      } else if (isEditing) {
        final.push(dp)
      }

      return final
    }, [])
  },
  /**
   * @param string email
   *  Comman separated emails
   * @param array users
   *  A user list where the emails find in
   */
  getUserIds: function (emails, users) {
    // transform to array
    if (emails.indexOf(',') !== -1) {
      emails = emails.split(',')
    } else {
      emails = [emails]
    }

    return emails.map((email) => {
      let u = _.find(users, { email: email })
      return u ? u.id : ''
    })
  },
  getUsersByIds: function (userIds, users) {
    return userIds.map(uid => _.find(users, { id: uid }))
  },
  getUserEmailsByIds: function (userIds, users) {
    return _.map(this.getUsersByIds(userIds, users), 'email')
  },
  getUserEmailById: function (userId, users) {
    let usersFound = this.getUserEmailsByIds([userId], users)
    if (usersFound.length > 0) {
      return _.head(usersFound)
    }
    return false
  },
  getWorkflowTransitionActiveState: function (currentTransition, userTransitionHistories) {
    return this.findByTransition(currentTransition, userTransitionHistories) !== undefined
  },
  getWorkflowTransitionStateHistories: function (currentTransition, userTransitionHistories) {
    return this.findByTransition(currentTransition, userTransitionHistories)
  },
  getWorkflowTransitionButtonActiveState: function (currentTransitionName, enabledTransitions) {
    return this.findByTransition({ transition: currentTransitionName }, enabledTransitions, false) !== undefined
  },
  findByTransition: function (item, iteratees, checkContext = true) {
    if (checkContext && this.isTransitionHasContext(item)) {
      return _.filter(iteratees, (o) => {
        return o.transition === item.transition && o.context.sub === item.context.sub
      })
    }

    if (!checkContext && typeof item.transition === 'string') {
      let splitIndex = item.transition.indexOf(':')
      if (splitIndex !== -1) {
        item.transition = item.transition.substr(0, splitIndex)
      }
    }
    return _.filter(iteratees, { transition: item.transition })
  },
  isTransitionHasContext: function (transition) {
    return transition.context && transition.context.sub
  }
}

export default UTILS
